<template>
  <div>
    <v-breadcrumbs :items="breadcrumbsItems" divider="/" active="breadcrumb-active"></v-breadcrumbs>

    <v-card width="558px">
      <v-card-title> Information </v-card-title>
      <v-card-text>
        <v-form data-vv-scope="form" v-model="form.valid">
          <v-text-field
            type="input"
            label="Name (EN)"
            variant="underlined"
            v-model="form.name.en"
            v-validate="'required'"
            data-vv-name="name.en"
            :error-messages="errors.collect('form.name.en')"
            clearable
          ></v-text-field>
          <v-text-field
            type="input"
            label="Name (TH)"
            v-model="form.name.th"
            v-validate="'required'"
            data-vv-name="name.th"
            :error-messages="errors.collect('form.name.th')"
            clearable
          ></v-text-field>
          <v-text-field
            type="input"
            label="Description (EN)"
            variant="underlined"
            v-model="form.description.en"
            clearable
          ></v-text-field>
          <v-text-field
            type="input"
            label="Description (TH)"
            variant="underlined"
            v-model="form.description.th"
            clearable
          ></v-text-field>
        </v-form>
      </v-card-text>

      <v-card-actions class="pa-7">
        <v-row class="mb-1">
          <v-btn color="primary" block @click="editProviderType">SAVE ALL</v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import Form from '../form/form';
import formMixin from '../Mixins/form';
import { Vue } from 'vue-property-decorator';
import providerService from '../services/providerTypes';

export default Vue.extend({
  mixins: [formMixin],
  data() {
    return {
      form: new Form({
        data() {
          return {
            name: {
              en: '',
              th: '',
            },
            description: {
              en: '',
              th: '',
            },
          };
        },
      }),
      breadcrumbsItems: [
        {
          text: 'Provider Type',
          disabled: false,
          href: '/provider/provider-type',
        },
      ],
    };
  },
  props: {
    providerTypeId: Number,
  },
  methods: {
    editProviderType() {
      this.$validator.validateAll('form').then((result) => {
        if (result) {
          providerService
            .editProviderTypeDetail(this.providerTypeId, this.form)
            .then(() => {
              this.getProviderDetail();
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    getProviderDetail() {
      providerService
        .providerTypeDetail(this.providerTypeId)
        .then((res) => {
          this.form.name.en = res.name_en;
          this.form.name.th = res.name_th;
          this.form.description.en = res.description_en;
          this.form.description.th = res.description_th;

          if (this.breadcrumbsItems.length > 1) {
            this.breadcrumbsItems.pop();
          }

          this.breadcrumbsItems = [
            ...this.breadcrumbsItems,
            {
              text: res.name_en,
              disabled: true,
            },
          ];
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.getProviderDetail();
  },
});
</script>
